export default __webpack_public_path__ + "2f2827586eff55a86c44fc81f73af046.png";